__turbopack_context__.v({
  "actionsOnly": "collection-offer-book-module__Yd-b7q__actionsOnly",
  "book": "collection-offer-book-module__Yd-b7q__book",
  "buyer": "collection-offer-book-module__Yd-b7q__buyer",
  "columns": "collection-offer-book-module__Yd-b7q__columns",
  "content": "collection-offer-book-module__Yd-b7q__content",
  "depth": "collection-offer-book-module__Yd-b7q__depth",
  "details": "collection-offer-book-module__Yd-b7q__details",
  "eligibility": "collection-offer-book-module__Yd-b7q__eligibility",
  "empty": "collection-offer-book-module__Yd-b7q__empty",
  "expand": "collection-offer-book-module__Yd-b7q__expand",
  "fullLevels": "collection-offer-book-module__Yd-b7q__fullLevels",
  "heading": "collection-offer-book-module__Yd-b7q__heading",
  "level": "collection-offer-book-module__Yd-b7q__level",
  "levelButton": "collection-offer-book-module__Yd-b7q__levelButton",
  "levels": "collection-offer-book-module__Yd-b7q__levels",
  "match": "collection-offer-book-module__Yd-b7q__match",
  "note": "collection-offer-book-module__Yd-b7q__note",
  "offerActions": "collection-offer-book-module__Yd-b7q__offerActions",
  "panel": "collection-offer-book-module__Yd-b7q__panel",
  "price": "collection-offer-book-module__Yd-b7q__price",
  "primary": "collection-offer-book-module__Yd-b7q__primary",
  "quantity": "collection-offer-book-module__Yd-b7q__quantity",
  "refresh": "collection-offer-book-module__Yd-b7q__refresh",
  "stats": "collection-offer-book-module__Yd-b7q__stats",
  "status": "collection-offer-book-module__Yd-b7q__status",
  "tabs": "collection-offer-book-module__Yd-b7q__tabs",
  "toolbar": "collection-offer-book-module__Yd-b7q__toolbar",
  "total": "collection-offer-book-module__Yd-b7q__total",
});
